import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

export default function Landing() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#ffffff', fontFamily: 'system-ui, -apple-system, sans-serif' }}>

      {/* Hero */}
      <header style={{
        background: 'linear-gradient(160deg, #16a34a 0%, #14532d 100%)',
        color: 'white',
        padding: '3rem 1.5rem 4rem',
      }}>
        <div style={{ maxWidth: '720px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ marginBottom: '2rem' }}>
            <Logo variant="light" size="large" />
          </div>
          <h1 style={{ fontSize: 'clamp(1.75rem, 5vw, 2.75rem)', fontWeight: '700', marginBottom: '1rem', lineHeight: '1.2', letterSpacing: '-0.02em' }}>
            Die Einkaufsliste für deine ganze Familie
          </h1>
          <p style={{ fontSize: '1.125rem', marginBottom: '2.5rem', opacity: 0.85, lineHeight: '1.7', maxWidth: '540px', margin: '0 auto 2.5rem' }}>
            Nie wieder doppelt kaufen oder vergessen. Teile Listen in Echtzeit – kostenlos, ohne Werbung.
          </p>

          {/* CTA Buttons */}
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '2.5rem' }}>
            <Link to="/register" style={{
              backgroundColor: 'white',
              color: '#16a34a',
              padding: '0.8rem 1.75rem',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              fontWeight: '600',
              textDecoration: 'none',
              display: 'inline-block',
              boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
            }}>
              Kostenlos starten
            </Link>
            <Link to="/login" style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: '1.5px solid rgba(255,255,255,0.6)',
              padding: '0.8rem 1.75rem',
              borderRadius: '0.5rem',
              fontSize: '1rem',
              fontWeight: '500',
              textDecoration: 'none',
              display: 'inline-block'
            }}>
              Anmelden
            </Link>
          </div>

          {/* Play Store Badge */}
          <a
            href="https://play.google.com/store/apps/details?id=app.meinelisten"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-block', textDecoration: 'none' }}
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/de_badge_web_generic.png"
              alt="Jetzt bei Google Play"
              style={{ height: '64px' }}
            />
          </a>
        </div>
      </header>

      {/* Features */}
      <main style={{ maxWidth: '900px', margin: '0 auto', padding: '5rem 1.5rem' }}>

        <p style={{ textAlign: 'center', fontSize: '0.875rem', fontWeight: '600', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#16a34a', marginBottom: '0.75rem' }}>
          Funktionen
        </p>
        <h2 style={{ textAlign: 'center', fontSize: '1.75rem', fontWeight: '700', color: '#111827', marginBottom: '3rem', letterSpacing: '-0.01em' }}>
          Alles was du brauchst
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
          gap: '1px',
          backgroundColor: '#e5e7eb',
          border: '1px solid #e5e7eb',
          borderRadius: '0.75rem',
          overflow: 'hidden',
          marginBottom: '5rem'
        }}>
          {[
            { icon: '→', title: 'Echtzeit-Synchronisation', text: 'Alle Listenmitglieder sehen Änderungen sofort – ohne Neuladen.' },
            { icon: '→', title: 'In-App-Chat', text: 'Schreib direkt in der Liste: Nachrichten in Echtzeit mit Lesebestätigungen und Push-Benachrichtigungen.' },
            { icon: '→', title: 'Vorlagen', text: 'Speichere Standardlisten als Vorlage und erstelle neue Listen mit einem Klick daraus.' },
            { icon: '→', title: 'Push-Benachrichtigungen', text: 'Werde informiert wenn jemand Artikel hinzufügt, abhakt oder dir schreibt.' },
            { icon: '→', title: 'Supermarkt-Navigation', text: 'Lege Gänge und Zonen an und folge der optimalen Einkaufsroute.' },
            { icon: '→', title: 'Smart-Kategorien', text: 'Artikel werden automatisch kategorisiert – über 200 deutsche Keywords.' },
            { icon: '→', title: 'Offline-Modus', text: 'Ohne Internet arbeiten. Änderungen werden synchronisiert sobald du wieder online bist.' },
            { icon: '→', title: 'Aufgabenlisten', text: 'Wechsle zwischen Einkaufsliste und To-do mit Fälligkeitsdaten und Erinnerungen.' },
          ].map((f) => (
            <div key={f.title} style={{ backgroundColor: '#ffffff', padding: '1.75rem' }}>
              <h3 style={{ fontSize: '0.9375rem', fontWeight: '600', color: '#111827', marginBottom: '0.4rem' }}>
                {f.title}
              </h3>
              <p style={{ fontSize: '0.875rem', color: '#6b7280', lineHeight: '1.6', margin: 0 }}>
                {f.text}
              </p>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div style={{ textAlign: 'center', borderTop: '1px solid #e5e7eb', paddingTop: '4rem' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '700', color: '#111827', marginBottom: '0.75rem' }}>
            Bereit loszulegen?
          </h2>
          <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
            Kostenlos registrieren – in einer Minute startklar.
          </p>
          <Link to="/register" style={{
            backgroundColor: '#16a34a',
            color: 'white',
            padding: '0.8rem 2rem',
            borderRadius: '0.5rem',
            fontSize: '1rem',
            fontWeight: '600',
            textDecoration: 'none',
            display: 'inline-block'
          }}>
            Kostenlos registrieren
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #e5e7eb',
        padding: '2rem 1.5rem',
        textAlign: 'center',
        color: '#9ca3af',
        fontSize: '0.875rem'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <p style={{ marginBottom: '0.5rem' }}>© 2026 meinelisten.app</p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center' }}>
            <Link to="/datenschutz" style={{ color: '#9ca3af', textDecoration: 'none' }}>Datenschutz</Link>
            <Link to="/impressum" style={{ color: '#9ca3af', textDecoration: 'none' }}>Impressum</Link>
          </div>
        </div>
      </footer>

    </div>
  );
}
